module.exports = __webpack_public_path__ + "img/home-logo.3450f42a.png";